// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"90":"2fedfbc5a65865b18e74","300":"11d1a52a1253b9408516","348":"729424e5dd251693137b","441":"2c5214a426488359bd5f","772":"39e3f56fbaf23859a1e2","794":"95427ce9590de308938e","820":"f018f35d65288d77b592"}[chunkId] + ".js";
};